import React from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import Button from "../../../../Elements/Button/Button.js";
import { useModal } from "../../../../../contexts/modalContext/modalContext.js";

const LanguageChangedModal = () => {
  const { getTextByKey } = useContent();
  const { closeModal } = useModal();
  return (
    <div className="order-language-changed-modal">
      <div className="language-changed-content">
        <h1>{getTextByKey("order-language-changed-title")}</h1>
        <p className="language-changed-text">
          {getTextByKey("order-language-changed-text")}
        </p>
        <Button className="embed-button" onClick={() => closeModal()}>
          {getTextByKey("ok")}
        </Button>
      </div>
    </div>
  );
};

export default LanguageChangedModal;
